import { AbstractRequirementMapper } from '@/features/CompanyQuestions/RequirementMapping/AbstractRequirementMapper';

export class VorschadenZukunft extends AbstractRequirementMapper {
  protected frontendKey = 'vorschaden';
}
